// -- Adaptive and Robust Control -- Control Systems ---------------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.85">{sub}</text>}
    </g>
  );
}

function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash ? '5 3' : 'none'} markerEnd={'url(#' + marker + ')'}/>
      {lbl && (
        <text x={lx || ((x1+x2)/2)} y={ly || ((y1+y2)/2 - 5)}
          textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>
      )}
    </g>
  );
}

function Card({ x, y, w, h, bg, bc, lines }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
      {lines.map((t, i) => (
        <text key={i} x={x+8} y={y+16+i*15}
          fontSize={i===0 ? '11' : '10'} fill={i===0 ? bc : '#444'} fontWeight={i===0 ? '700' : '400'}>{t}</text>
      ))}
    </g>
  );
}

// =================================================================
// Diagram 1 -- Adaptive vs Robust philosophy comparison
// =================================================================
function DiagramPhilosophy() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Two Strategies for Dealing with Uncertainty: Adaptive vs Robust</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Central uncertainty box */}
        <rect x={350} y={140} width={200} height={80} rx={8} fill={LTORG} stroke={ORANGE} strokeWidth="2.5"/>
        <text x={450} y={176} textAnchor="middle" fontSize="15" fill={ORANGE} fontWeight="700">UNCERTAINTY</text>
        <text x={450} y={193} textAnchor="middle" fontSize="10" fill={ORANGE}>Unknown / varying plant parameters</text>
        <text x={450} y={207} textAnchor="middle" fontSize="9" fill="#888">disturbances, model mismatch, wear</text>

        {/* Adaptive path */}
        <rect x={20} y={60} width={290} height={240} rx={6} fill="#fff" stroke={BLUE} strokeWidth="2"/>
        <rect x={20} y={60} width={290} height={36} rx={6} fill={BLUE} opacity="0.1"/>
        <text x={165} y={85} textAnchor="middle" fontSize="15" fill={BLUE} fontWeight="700">ADAPTIVE CONTROL</text>

        <Arr x1={312} y1={180} x2={350} y2={180} color={BLUE} marker="aBlue" dash={true}/>
        <text x={296} y={172} textAnchor="middle" fontSize="9" fill={BLUE}>observe</text>
        <text x={296} y={183} textAnchor="middle" fontSize="9" fill={BLUE}>and learn</text>

        {[
          { y:104, lines:['Strategy: MEASURE then CHANGE gains'] },
          { y:136, lines:['- Estimates unknown parameters online'] },
          { y:152, lines:['- Controller gains updated in real-time'] },
          { y:168, lines:['- Adapts to slow parameter drift'] },
          { y:184, lines:['- Requires persistent excitation (PE)'] },
          { y:200, lines:['- Can be unstable during transients'] },
          { y:218, lines:['Key methods:'] },
          { y:233, lines:['  MRAC, Self-Tuning Regulator,'] },
          { y:248, lines:['  Gain Scheduling, Extremum Seeking'] },
          { y:268, lines:['Analogy: learning to ride a new bicycle'] },
        ].map(({ y, lines }) => (
          <text key={y} x={30} y={y} fontSize={y===104||y===268?'10':'9.5'}
            fill={y===104?BLUE:y===268?'#888':'#333'}
            fontWeight={y===104?'700':'400'}>{lines[0]}</text>
        ))}

        {/* Robust path */}
        <rect x={590} y={60} width={300} height={240} rx={6} fill="#fff" stroke={RED} strokeWidth="2"/>
        <rect x={590} y={60} width={300} height={36} rx={6} fill={RED} opacity="0.1"/>
        <text x={740} y={85} textAnchor="middle" fontSize="15" fill={RED} fontWeight="700">ROBUST CONTROL</text>

        <Arr x1={550} y1={180} x2={590} y2={180} color={RED} marker="aRed" dash={true}/>
        <text x={570} y={172} textAnchor="middle" fontSize="9" fill={RED}>designed</text>
        <text x={570} y={183} textAnchor="middle" fontSize="9" fill={RED}>for worst case</text>

        {[
          { y:104, lines:['Strategy: DESIGN once for worst-case'] },
          { y:136, lines:['- Tolerates bounded uncertainty without changing'] },
          { y:152, lines:['- Gains are FIXED (offline design)'] },
          { y:168, lines:['- Guarantees stability over uncertainty set'] },
          { y:184, lines:['- No online computation (except eval)'] },
          { y:200, lines:['- May be conservative (over-penalises)'] },
          { y:218, lines:['Key methods:'] },
          { y:233, lines:['  H-infinity, mu-synthesis,'] },
          { y:248, lines:['  Sliding Mode, Quantitative Feedback Theory'] },
          { y:268, lines:['Analogy: building a bridge for max load'] },
        ].map(({ y, lines }) => (
          <text key={y} x={600} y={y} fontSize={y===104||y===268?'10':'9.5'}
            fill={y===104?RED:y===268?'#888':'#333'}
            fontWeight={y===104?'700':'400'}>{lines[0]}</text>
        ))}

        {/* Bottom comparison */}
        <rect x={10} y={308} width={880} height={44} rx={4} fill="#fff" stroke={BORDER}/>
        {[
          { x:18,  color:BLUE,   text:'Adaptive: converges to true parameters; best long-run performance; more complex stability analysis' },
          { x:460, color:RED,    text:'Robust: fixed, simple, guaranteed bounds; possibly conservative; no online identification needed' },
        ].map(({ x, color, text }) => (
          <text key={x} x={x} y={334} fontSize="9.5" fill={color}>{text}</text>
        ))}
      </svg>
      <div style={S.dCaption}>
        Adaptive and robust control represent two fundamentally different answers to the same question: how should a controller behave when plant parameters are unknown or changing? Adaptive control measures and tracks the uncertainty, continuously updating its gains. Robust control accepts the uncertainty upfront and designs fixed gains that work for the entire specified range. The choice depends on how fast parameters change, how much computation is available, and how tight the performance requirements are.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 2 -- Gain scheduling
// =================================================================
function DiagramGainScheduling() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Gain Scheduling -- Pre-computed Gains Indexed by Operating Condition</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: conceptual diagram */}
        <rect x={10} y={10} width={370} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={195} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Gain Scheduling Architecture</text>

        {/* Scheduling variable */}
        <Blk x={24} y={46} w={130} h={40} fill={LTORG} stroke={ORANGE} label="Scheduling" sub="variable rho" fs={10}/>

        {/* Lookup table */}
        <Blk x={24} y={110} w={130} h={40} fill={LTBLU} stroke={BLUE} label="Gain Table" sub="K1,K2,...,Kn" fs={10}/>

        {/* Interpolation */}
        <Blk x={24} y={174} w={130} h={40} fill={LTPUR} stroke={PURPLE} label="Interpolation" sub="K(rho)" fs={10}/>

        {/* Linear controller */}
        <Blk x={24} y={238} w={130} h={40} fill={LTRED} stroke={RED} label="Controller" sub="C(s, K(rho))" fs={10}/>

        <Arr x1={89} y1={86} x2={89} y2={110} color={ORANGE} marker="aOrange"/>
        <Arr x1={89} y1={150} x2={89} y2={174} color={BLUE} marker="aBlue"/>
        <Arr x1={89} y1={214} x2={89} y2={238} color={PURPLE} marker="aPurple"/>

        {/* Plant */}
        <Blk x={220} y={162} w={130} h={40} fill={LTGRN} stroke={GREEN} label="Plant" sub="G(s, rho(t))" fs={10}/>

        {/* Feedback loop */}
        <Arr x1={154} y1={258} x2={220} y2={182} color={RED} marker="aRed" lbl="u" lx={195} ly={218}/>
        <line x1={350} y1={182} x2={350} y2={270} stroke={GREEN} strokeWidth="1.8"/>
        <line x1={350} y1={270} x2={89} y2={270} stroke={GREEN} strokeWidth="1.8"/>
        <Arr x1={89} y1={270} x2={89} y2={278} color={GREEN} marker="aGreen" lbl="y" lx={220} ly={264}/>

        {/* rho from plant */}
        <line x1={350} y1={182} x2={370} y2={182} stroke={ORANGE} strokeWidth="1.8"/>
        <line x1={370} y1={60} x2={370} y2={182} stroke={ORANGE} strokeWidth="1.8" strokeDasharray="4 2"/>
        <Arr x1={370} y1={60} x2={154} y2={66} color={ORANGE} marker="aOrange" lbl="rho(t)" lx={262} ly={55}/>

        {/* Info boxes */}
        {[
          { y:296, bg:LTORG, bc:ORANGE, lines:['Scheduling variable rho','Any measurable signal: velocity, altitude,','temperature, operating point index'] },
          { y:332, bg:LTBLU, bc:BLUE,   lines:['Gain table','K_i designed at each operating point','by pole placement or LQR'] },
        ].map(({ y, bg, bc, lines }) => y < 370 ? (
          <Card key={y} x={14} y={y} w={354} h={30} bg={bg} bc={bc} lines={lines}/>
        ) : null)}

        {/* Right: scheduling variable plots */}
        <rect x={398} y={10} width={492} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={644} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Aircraft Example: Gains vs Mach Number</text>

        {(() => {
          const bx = 420, by = 40, bw = 460, bh = 130;
          const machs = [0, 0.3, 0.6, 0.9, 1.2, 1.5, 1.8];
          // Simulated K_p, K_d as functions of Mach
          const Kp = [2.0, 1.8, 1.4, 0.9, 0.6, 0.8, 1.0];
          const Kd = [0.5, 0.6, 0.8, 1.2, 1.5, 1.3, 1.1];
          const toX = m => bx + (m / 1.8) * bw;
          const toYk = v => by + bh - v * bh * 0.55;

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              {machs.map(m => (
                <line key={m} x1={toX(m)} y1={by} x2={toX(m)} y2={by+bh} stroke="#f0f0f0" strokeWidth="1"/>
              ))}
              {[0,0.5,1.0,1.5,2.0].map(v => (
                <line key={v} x1={bx} y1={toYk(v)} x2={bx+bw} y2={toYk(v)} stroke="#f0f0f0" strokeWidth="1"/>
              ))}
              <polyline points={Kp.map((v,i) => toX(machs[i])+','+toYk(v)).join(' ')}
                fill="none" stroke={RED} strokeWidth="2.2"/>
              <polyline points={Kd.map((v,i) => toX(machs[i])+','+toYk(v)).join(' ')}
                fill="none" stroke={BLUE} strokeWidth="2.2"/>
              {Kp.map((v, i) => (
                <circle key={'kp'+i} cx={toX(machs[i])} cy={toYk(v)} r={4} fill={RED}/>
              ))}
              {Kd.map((v, i) => (
                <circle key={'kd'+i} cx={toX(machs[i])} cy={toYk(v)} r={4} fill={BLUE}/>
              ))}
              <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
              <text x={bx+bw/2} y={by+bh+16} textAnchor="middle" fontSize="10" fill="#777">Mach number (scheduling variable)</text>
              {machs.map(m => (
                <text key={'ml'+m} x={toX(m)} y={by+bh+28} textAnchor="middle" fontSize="9" fill="#bbb">{m.toFixed(1)}</text>
              ))}
              <text x={bx+10} y={by+18} fontSize="9.5" fill={RED} fontWeight="700">Kp (proportional gain)</text>
              <text x={bx+10} y={by+32} fontSize="9.5" fill={BLUE} fontWeight="700">Kd (derivative gain)</text>
            </g>
          );
        })()}

        {/* Pros/cons */}
        {[
          { y:190, bg:LTGRN, bc:GREEN, lines:[
            'Advantages',
            'Simple -- linear controller at each point',
            'Well-understood stability at each operating point',
            'Easy to implement (table lookup + interpolation)',
            'Widely used in aerospace (autopilots), automotive ECU',
          ]},
          { y:272, bg:LTRED, bc:RED, lines:[
            'Limitations',
            'No stability guarantee BETWEEN operating points',
            'Manual design at many points (expensive)',
            'Fails for fast-varying scheduling variable',
            'Transition dynamics can be problematic',
          ]},
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={406} y={y} w={476} h={76} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Gain scheduling is the simplest form of adaptive control: the controller gains are pre-computed at multiple operating points (e.g., Mach numbers for an aircraft) and stored in a table. At runtime, the scheduling variable is measured and the gains are interpolated. The approach is popular because each individual design uses familiar linear tools, but it provides no global stability guarantee -- the system might oscillate during transitions between operating points.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 3 -- MRAC architecture
// =================================================================
function DiagramMRAC() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Model Reference Adaptive Control (MRAC) -- Following a Reference Model</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Reference model (ideal plant) */}
        <rect x={10} y={10} width={880} height={4} rx={2} fill={BORDER}/>
        <text x={16} y={22} fontSize="10" fill="#999" fontStyle="italic">Reference Model Path (desired behaviour)</text>

        <Arr x1={14} y1={64} x2={50} y2={64} color={GREEN} marker="aGreen"/>
        <text x={8} y={58} fontSize="11" fill={GREEN} fontWeight="700">r</text>

        <Blk x={50} y={44} w={130} h={40} fill={LTGRN} stroke={GREEN} label="Reference Model" sub="Gm(s) -- desired" fs={10}/>
        <Arr x1={180} y1={64} x2={280} y2={64} color={GREEN} marker="aGreen" lbl="ym" lx={228} ly={56}/>
        <circle cx={280} cy={64} r={5} fill={GREEN}/>

        {/* Actual plant path */}
        <rect x={10} y={112} width={880} height={4} rx={2} fill={BORDER}/>
        <text x={16} y={124} fontSize="10" fill="#999" fontStyle="italic">Actual Plant Path</text>

        <Arr x1={14} y1={164} x2={50} y2={164} color={RED} marker="aRed"/>
        <text x={8} y={158} fontSize="11" fill={RED} fontWeight="700">r</text>

        {/* Adjustable controller */}
        <Blk x={50} y={144} w={130} h={40} fill={LTRED} stroke={RED} label="Controller C(theta)" sub="adjustable gains" fs={10}/>
        <Arr x1={180} y1={164} x2={260} y2={164} color={RED} marker="aRed" lbl="u" lx={218} ly={156}/>

        {/* Plant */}
        <Blk x={260} y={144} w={130} h={40} fill={LTBLU} stroke={BLUE} label="Plant G(s,p)" sub="unknown params p" fs={10}/>
        <Arr x1={390} y1={164} x2={480} y2={164} color={BLUE} marker="aBlue" lbl="yp" lx={433} ly={156}/>
        <circle cx={480} cy={164} r={5} fill={BLUE}/>

        {/* Error computation */}
        <line x1={480} y1={64} x2={480} y2={230} stroke="#aaa" strokeWidth="1.5"/>
        <circle cx={480} cy={64} r={4} fill={GREEN}/>
        <circle cx={530} cy={210} r={16} fill="#fff" stroke={PURPLE} strokeWidth="2"/>
        <text x={530} y={215} textAnchor="middle" fontSize="15" fill={PURPLE} fontWeight="700">-</text>
        <line x1={480} y1={164} x2={530} y2={164} stroke={BLUE} strokeWidth="1.8"/>
        <Arr x1={530} y1={164} x2={530} y2={194} color={BLUE} marker="aBlue"/>
        <line x1={480} y1={230} x2={530} y2={230} stroke={GREEN} strokeWidth="1.8"/>
        <Arr x1={530} y1={230} x2={530} y2={226} color={GREEN} marker="aGreen"/>
        <Arr x1={546} y1={210} x2={650} y2={210} color={PURPLE} marker="aPurple" lbl="e = yp - ym" lx={596} ly={202}/>

        {/* Adaptation mechanism */}
        <rect x={650} y={174} width={220} height={72} rx={5} fill={LTORG} stroke={ORANGE} strokeWidth="2"/>
        <text x={760} y={196} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">ADAPTATION LAW</text>
        <text x={760} y={212} textAnchor="middle" fontSize="10" fill={ORANGE}>d(theta)/dt = -gamma * e * phi</text>
        <text x={760} y={227} textAnchor="middle" fontSize="9" fill="#555">phi: regressor vector</text>
        <text x={760} y={240} textAnchor="middle" fontSize="9" fill="#555">gamma: adaptation gain</text>

        {/* theta back to controller */}
        <line x1={760} y1={246} x2={760} y2={290} stroke={ORANGE} strokeWidth="1.8"/>
        <line x1={760} y1={290} x2={115} y2={290} stroke={ORANGE} strokeWidth="1.8"/>
        <Arr x1={115} y1={290} x2={115} y2={184} color={ORANGE} marker="aOrange" lbl="theta(t) updated" lx={50} ly={237}/>

        {/* Bottom info */}
        <rect x={10} y={308} width={880} height={44} rx={4} fill="#fff" stroke={BORDER}/>
        {[
          { x:18, color:GREEN,  text:'Reference model: specifies desired closed-loop response (damping, bandwidth)' },
          { x:18, color:PURPLE, text:'Error signal e = yp - ym drives adaptation: push plant response toward ideal model' },
          { x:480, color:ORANGE, text:'MIT rule: d(theta)/dt = -gamma * e * (de/d_theta): gradient descent on e^2/2' },
          { x:480, color:BLUE,   text:'Lyapunov-based: adaptation law designed to ensure e -> 0 (provably stable)' },
        ].filter(({x, text}, i) => i < 2).map(({ x, color, text }, i) => (
          <text key={i} x={x} y={324+i*14} fontSize="9.5" fill={color}>{text}</text>
        ))}
        <text x={18} y={324} fontSize="9.5" fill={GREEN}>Reference model: specifies desired CL response (damping, bandwidth, speed)</text>
        <text x={18} y={338} fontSize="9.5" fill={PURPLE}>Error e = yp - ym drives adaptation: gains updated to make plant track ideal model</text>
        <text x={480} y={324} fontSize="9.5" fill={ORANGE}>MIT rule: d(theta)/dt = -gamma * e * partial(e)/partial(theta)</text>
        <text x={480} y={338} fontSize="9.5" fill={BLUE}>Lyapunov method: design law to guarantee e^2 + param_error^2 decreases</text>
      </svg>
      <div style={S.dCaption}>
        In MRAC, the desired closed-loop behaviour is specified by a reference model Gm(s). The adaptation law continuously adjusts the controller parameters theta so that the plant output yp tracks the reference model output ym. The error e = yp - ym drives the parameter updates. Two main adaptation laws exist: the MIT rule (gradient descent on the error squared) and Lyapunov-based methods (which provide provable stability guarantees).
      </div>
    </div>
  );
}

// =================================================================
// Diagram 4 -- MIT Rule and parameter convergence
// =================================================================
function DiagramMITRule() {
  const W = 900, H = 340;
  const bx = 50, by = 30, bw = 520, bh = 280;
  const tMax = 10.0;
  const toX = t => bx + (t / tMax) * bw;
  const toY = v => by + bh/2 - v * bh * 0.35;

  // Simulate simple 1D MRAC: theta adapts to cancel unknown gain
  // True gain: 2.0, initial estimate: 0.5, gamma=0.8
  const thetaTrue = 2.0;
  let theta = 0.5, e = 0.8, gamma = 0.6;
  const series = [{ t: 0, theta: 0.5, e: 0.8, y: 0.3 }];
  for (let k = 1; k <= 100; k++) {
    const t = k * tMax / 100;
    const phi = 0.9;
    const dTheta = -gamma * e * phi;
    theta += dTheta * tMax / 100;
    e = (thetaTrue - theta) * 0.5 * Math.exp(-0.5 * (thetaTrue - theta) * t * 0.3);
    const y = 1 - Math.exp(-t / (1 + Math.abs(thetaTrue - theta) * 0.5));
    series.push({ t, theta, e, y });
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>MIT Rule Adaptation -- Parameter Convergence and Error Decay</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>

        {/* Grid */}
        {[-0.6,-0.4,-0.2,0,0.2,0.4,0.6,0.8,1.0].map(v => (
          <g key={v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke={Math.abs(v)<0.01?'#bbb':'#f5f0f0'} strokeWidth={Math.abs(v)<0.01?1.3:1}/>
            <text x={bx-5} y={toY(v)+4} textAnchor="end" fontSize="9" fill="#ccc">{v.toFixed(1)}</text>
          </g>
        ))}
        {[0,2,4,6,8,10].map(t => (
          <g key={t}>
            <line x1={toX(t)} y1={by} x2={toX(t)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toX(t)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">{t}</text>
          </g>
        ))}

        {/* Parameter theta trajectory */}
        <polyline points={series.map(({ t, theta: th }) => toX(t)+','+toY(th - thetaTrue)).join(' ')}
          fill="none" stroke={ORANGE} strokeWidth="2.2"/>

        {/* Error e */}
        <polyline points={series.map(({ t, e: err }) => toX(t)+','+toY(err)).join(' ')}
          fill="none" stroke={RED} strokeWidth="2"/>

        {/* y response */}
        <polyline points={series.map(({ t, y }) => toX(t)+','+toY(y)).join(' ')}
          fill="none" stroke={BLUE} strokeWidth="2" strokeDasharray="6 3"/>

        {/* Reference at 1 */}
        <line x1={bx} y1={toY(1)} x2={bx+bw} y2={toY(1)} stroke="#bbb" strokeWidth="1.2" strokeDasharray="4 3"/>

        {/* Axes */}
        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <line x1={bx} y1={by}    x2={bx}    y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <text x={bx+bw/2} y={by+bh+28} textAnchor="middle" fontSize="11" fill="#777">Time t</text>

        {/* Labels */}
        <line x1={bx+10} y1={by+bh-14} x2={bx+36} y2={by+bh-14} stroke={ORANGE} strokeWidth="2"/>
        <text x={bx+40} y={by+bh-10} fontSize="9.5" fill={ORANGE} fontWeight="700">theta error (theta - theta_true)</text>
        <line x1={bx+240} y1={by+bh-14} x2={bx+266} y2={by+bh-14} stroke={RED} strokeWidth="2"/>
        <text x={bx+270} y={by+bh-10} fontSize="9.5" fill={RED} fontWeight="700">tracking error e</text>
        <line x1={bx+380} y1={by+bh-14} x2={bx+406} y2={by+bh-14} stroke={BLUE} strokeWidth="2" strokeDasharray="6 3"/>
        <text x={bx+410} y={by+bh-10} fontSize="9.5" fill={BLUE} fontWeight="700">output y</text>

        {/* Right panel: MIT rule derivation */}
        <rect x={590} y={by} width={300} height={bh} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={740} y={by+18} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">MIT Rule Derivation</text>

        {[
          { y:by+26, bg:LTRED, bc:RED, lines:['Cost function','J(theta) = (1/2) * e(theta)^2','Minimise wrt controller params theta'] },
          { y:by+90, bg:LTORG, bc:ORANGE, lines:['Gradient descent on J','d(theta)/dt = -gamma * partial(J)/partial(theta)','= -gamma * e * partial(e)/partial(theta)'] },
          { y:by+154, bg:LTBLU, bc:BLUE, lines:['Sensitivity signal phi','phi = partial(e)/partial(theta)','Measures how e changes with theta'] },
          { y:by+218, bc:GREEN, bg:LTGRN, lines:['MIT update law','d(theta)/dt = -gamma * e * phi','gamma: adaptation rate; larger = faster'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={596} y={y} w={288} h={60} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        The MIT rule updates controller parameters theta along the negative gradient of J = (1/2)e^2: d(theta)/dt = -gamma*e*phi where phi = partial(e)/partial(theta) is the sensitivity of the error to parameters. The parameter estimate (orange) converges from the initial guess toward the true value; the tracking error (red) decays to zero; the output (blue) approaches the reference. The adaptation rate gamma controls the speed of convergence -- too large causes instability.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 5 -- Recursive Least Squares (parameter identification)
// =================================================================
function DiagramRLS() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Recursive Least Squares (RLS) -- Online Parameter Identification</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: algorithm steps */}
        <rect x={10} y={10} width={415} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={415} height={36} rx={5} fill={BLUE} opacity="0.1"/>
        <text x={222} y={33} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700">RLS Algorithm (recursive update)</text>

        <rect x={18} y={54} width={399} height={52} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={222} y={72} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700">Model: y(k) = phi(k)^T * theta + noise</text>
        <text x={222} y={88} textAnchor="middle" fontSize="9.5" fill="#555">theta: unknown parameter vector; phi: regressor (known signals)</text>
        <text x={222} y={100} textAnchor="middle" fontSize="9.5" fill="#555">e.g., ARX model: y(k) = -a1*y(k-1) + b1*u(k-1) + b2*u(k-2)</text>

        {[
          { y:114, color:RED,    bg:LTRED, label:'Step 1: Gain (Kalman-like)',
            eq: 'L(k) = P(k-1)*phi(k) / (lambda + phi(k)^T*P(k-1)*phi(k))',
            note:'L(k): RLS gain; lambda: forgetting factor (0.95-1.0)' },
          { y:168, color:ORANGE, bg:LTORG, label:'Step 2: Update estimate',
            eq: 'theta(k) = theta(k-1) + L(k)*(y(k) - phi(k)^T*theta(k-1))',
            note:'Prediction error e(k) = y(k) - phi^T*theta(k-1)' },
          { y:222, color:GREEN,  bg:LTGRN, label:'Step 3: Update covariance',
            eq: 'P(k) = (1/lambda) * (I - L(k)*phi(k)^T) * P(k-1)',
            note:'P(k): parameter uncertainty; grows if lambda < 1 (old data discounted)' },
          { y:276, color:PURPLE, bg:LTPUR, label:'Forgetting factor lambda',
            eq: 'lambda = 1: standard LS (all data equal weight)',
            note:'lambda < 1: exponentially forget old data; tracks time-varying params' },
        ].map(({ y, color, bg, label, eq, note }) => (
          <g key={y}>
            <rect x={18} y={y} width={399} height={50} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={26} y={y+15} fontSize="11" fill={color} fontWeight="700">{label}</text>
            <text x={26} y={y+30} fontSize="9.5" fill="#333" fontFamily="'Courier New',monospace">{eq}</text>
            <text x={26} y={y+45} fontSize="9.5" fill="#666">{note}</text>
          </g>
        ))}

        {/* Right: convergence simulation */}
        <rect x={445} y={10} width={445} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={667} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">RLS Parameter Convergence Example</text>

        {(() => {
          const bx = 458, by = 38, bw = 422, bh = 200;
          const N = 60;
          // True params: theta = [0.7, -0.3, 0.5]
          const true_theta = [0.7, -0.3, 0.5];
          let theta = [0.0, 0.0, 0.0];
          let P = [[10,0,0],[0,10,0],[0,0,10]];
          const est = [{ k:0, t0: 0, t1: 0, t2: 0 }];
          for (let k = 1; k <= N; k++) {
            const phi = [Math.cos(k*0.3), Math.sin(k*0.2), 1];
            const y_true = true_theta.reduce((s,t,i) => s + t*phi[i], 0) + (Math.random()-0.5)*0.05;
            const ypred = theta.reduce((s,t,i) => s + t*phi[i], 0);
            const err = y_true - ypred;
            // Gain L = P*phi / (1 + phi^T P phi)
            const Pphi = P.map(row => row.reduce((s,v,j) => s+v*phi[j], 0));
            const denom = 1 + phi.reduce((s,v,j) => s+v*Pphi[j], 0);
            const L = Pphi.map(v => v/denom);
            theta = theta.map((t,i) => t + L[i]*err);
            P = P.map((row,i) => row.map((v,j) => v - L[i]*Pphi[j]));
            est.push({ k, t0: theta[0], t1: theta[1], t2: theta[2] });
          }

          const toXr = k => bx + (k/N) * bw;
          const toYr = v => by + bh/2 - v * bh * 0.7;

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              {[-0.5,0,0.5,1.0].map(v => (
                <g key={v}>
                  <line x1={bx} y1={toYr(v)} x2={bx+bw} y2={toYr(v)} stroke="#f0f0f0" strokeWidth="1"/>
                  <text x={bx-4} y={toYr(v)+4} textAnchor="end" fontSize="8" fill="#ccc">{v.toFixed(1)}</text>
                </g>
              ))}
              {/* True param lines */}
              {true_theta.map((t,i) => (
                <line key={'tp'+i} x1={bx} y1={toYr(t)} x2={bx+bw} y2={toYr(t)}
                  stroke={[RED,BLUE,GREEN][i]} strokeWidth="1" strokeDasharray="4 2" opacity="0.4"/>
              ))}
              {/* Estimates */}
              <polyline points={est.map(({ k, t0 }) => toXr(k)+','+toYr(t0)).join(' ')}
                fill="none" stroke={RED} strokeWidth="2"/>
              <polyline points={est.map(({ k, t1 }) => toXr(k)+','+toYr(t1)).join(' ')}
                fill="none" stroke={BLUE} strokeWidth="2"/>
              <polyline points={est.map(({ k, t2 }) => toXr(k)+','+toYr(t2)).join(' ')}
                fill="none" stroke={GREEN} strokeWidth="2"/>
              <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1"/>
              <text x={bx+bw/2} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#777">Time steps k</text>
              <text x={bx+10} y={by+14} fontSize="9" fill={RED} fontWeight="700">theta1 (true=0.7)</text>
              <text x={bx+10} y={by+26} fontSize="9" fill={BLUE} fontWeight="700">theta2 (true=-0.3)</text>
              <text x={bx+10} y={by+38} fontSize="9" fill={GREEN} fontWeight="700">theta3 (true=0.5)</text>
            </g>
          );
        })()}

        {[
          { y:252, bg:LTORG, bc:ORANGE, lines:['Persistent excitation (PE) condition','phi(k) must be sufficiently "rich" to ensure convergence','Without PE: parameters may converge to wrong values'] },
          { y:294, bg:LTBLU, bc:BLUE,   lines:['Indirect vs Direct adaptive','Indirect: estimate plant params, then design controller','Direct: directly estimate controller params (like MRAC)'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={453} y={y} w={429} h={38} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Recursive Least Squares estimates the unknown parameter vector theta online, one measurement at a time. The algorithm is identical in structure to the Kalman filter update (the gain L plays the role of the Kalman gain). The forgetting factor lambda discounts old data, allowing tracking of slowly time-varying parameters. The convergence rate depends on the richness of the input signal -- persistent excitation is required to identify all parameters simultaneously.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 6 -- Sliding Mode Control
// =================================================================
function DiagramSlidingMode() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sliding Mode Control (SMC) -- Robust Nonlinear Control via Switching</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: phase plane with sliding surface */}
        <rect x={10} y={10} width={360} height={350} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={185} y={28} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Phase Plane: Sliding Surface and Trajectories</text>

        {(() => {
          const bx=22, by=38, bw=335, bh=290;
          const cx=bx+bw/2, cy=by+bh/2;
          const sc=50;
          const toX=r=>cx+r*sc, toY=i=>cy-i*sc;

          // Sliding surface: s = x_dot + c*x = 0, i.e., line through origin
          const c=1;
          // Surface line
          const x1s=-2.5, y1s=c*2.5, x2s=2.5, y2s=-c*2.5;

          // Trajectories converging to surface from both sides
          const traj1 = [[2.5,0.5],[2.0,0.2],[1.6,0.0],[1.3,-0.2],[1.0,-0.4],[0.8,-0.5],
                         [0.6,-0.5],[0.4,-0.4],[0.2,-0.2],[0,0]];
          const traj2 = [[-2,-1],[-1.8,-0.8],[-1.6,-0.6],[-1.3,-0.4],[-1.0,-0.2],
                         [-0.7,-0.1],[-0.4,0.0],[-0.2,0.0],[0,0]];
          const traj3 = [[1.5,2],[1.2,1.4],[0.9,0.8],[0.6,0.3],[0.3,0],[0,0]];

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              {/* Axes */}
              <line x1={bx} y1={cy} x2={bx+bw} y2={cy} stroke="#ccc" strokeWidth="1.2"/>
              <line x1={cx} y1={by} x2={cx} y2={by+bh} stroke="#ccc" strokeWidth="1.2"/>
              <text x={bx+bw-4} y={cy+12} textAnchor="end" fontSize="9" fill="#aaa">x (position)</text>
              <text x={cx+4} y={by+14} fontSize="9" fill="#aaa">x_dot (velocity)</text>

              {/* Sliding surface */}
              <line x1={toX(x1s)} y1={toY(y1s)} x2={toX(x2s)} y2={toY(y2s)}
                stroke={RED} strokeWidth="2.5"/>
              <text x={toX(2.2)} y={toY(-2.5)} fontSize="10" fill={RED} fontWeight="700">s=0</text>
              <text x={toX(2.2)} y={toY(-2.5)+14} fontSize="8" fill={RED}>sliding surface</text>

              {/* Shading above/below surface */}
              <polygon points={[toX(x1s)+','+toY(y1s), toX(x2s)+','+toY(y2s), (bx+bw)+','+by, bx+','+by].join(' ')}
                fill={BLUE} opacity="0.06"/>
              <polygon points={[toX(x1s)+','+toY(y1s), toX(x2s)+','+toY(y2s), (bx+bw)+','+(by+bh), bx+','+(by+bh)].join(' ')}
                fill={ORANGE} opacity="0.06"/>

              {/* Trajectories */}
              {[traj1, traj2, traj3].map((traj, ti) => (
                <polyline key={'tr'+ti}
                  points={traj.map(([x,y]) => toX(x)+','+toY(y)).join(' ')}
                  fill="none" stroke={BLUE} strokeWidth="2" opacity="0.7"/>
              ))}

              {/* Chattering on surface */}
              {[0.8,0.5,0.3].map((x,i) => {
                const y_surf = -c*x;
                return (
                  <g key={'ch'+i}>
                    <path d={'M '+toX(x)+','+toY(y_surf+0.15*(i%2===0?1:-1))+' L '+toX(x-0.15)+','+toY(y_surf-0.1*(i%2===0?1:-1))}
                      stroke={ORANGE} strokeWidth="1.5" fill="none"/>
                  </g>
                );
              })}

              {/* Labels */}
              <text x={bx+8} y={by+20} fontSize="9" fill={BLUE}>s &gt; 0: u = -k</text>
              <text x={bx+8} y={by+32} fontSize="9" fill={ORANGE}>s &lt; 0: u = +k</text>
            </g>
          );
        })()}

        {/* Right: equations and properties */}
        <rect x={385} y={10} width={505} height={350} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={637} y={28} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">SMC Design and Analysis</text>

        <rect x={393} y={36} width={489} height={52} rx={4} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={637} y={55} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700">Sliding surface: s(x) = 0  (design choice)</text>
        <text x={637} y={71} textAnchor="middle" fontSize="10" fill="#555" fontFamily="'Courier New',monospace">e.g., s = e_dot + c*e  (1st order: c &gt; 0)</text>
        <text x={637} y={83} textAnchor="middle" fontSize="9" fill="#555">s=0 defines desired dynamics; c: bandwidth</text>

        {[
          { y:96, color:ORANGE, bg:LTORG, lines:['Reaching condition (Lyapunov)','V = (1/2)*s^2  must decrease: s * s_dot &lt; -eta * |s|','=> system trajectory always moves toward s=0'] },
          { y:154, color:RED,   bg:LTRED, lines:['Discontinuous control law','u_eq + u_sw; u_sw = -k * sign(s)',  'k must exceed bound on disturbance: k &gt; |d|_max'] },
          { y:212, color:BLUE,  bg:LTBLU, lines:['Chattering problem','Discontinuous sign(s) causes high-frequency switching','Real actuators cannot follow -- boundary layer solution'] },
          { y:270, color:GREEN, bg:LTGRN, lines:['Boundary layer (smooth SMC)','Replace sign(s) with sat(s/phi)  or  s/(|s|+eps)','Eliminates chattering; small tracking error in layer'] },
          { y:316, color:PURPLE,bg:LTPUR, lines:['Robustness property','If k &gt; sup|d(t)|: robust to bounded disturbances d(t)','Uncertainty does not affect sliding mode dynamics'] },
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={393} y={y} w={489} h={52} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Sliding Mode Control forces the system state onto a designer-specified surface s(x)=0 by switching control sign based on which side of the surface the state is on. Once on the surface, the state slides toward the origin with dynamics determined entirely by the surface design -- independent of plant uncertainties and bounded disturbances. The main limitation is chattering: high-frequency switching that real actuators cannot follow, mitigated by a boundary layer or higher-order SMC.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 7 -- H-infinity framework
// =================================================================
function DiagramHInfinity() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>H-infinity Robust Control -- Minimise Worst-Case Gain from Disturbance to Error</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Standard P-K interconnection */}
        <rect x={10} y={10} width={430} height={260} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={225} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Standard P-K (Generalized Plant) Form</text>

        {/* P block (generalized plant) */}
        <rect x={130} y={50} width={180} height={130} rx={6} fill={LTBLU} stroke={BLUE} strokeWidth="2"/>
        <text x={220} y={112} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">P(s)</text>
        <text x={220} y={128} textAnchor="middle" fontSize="10" fill={BLUE}>Generalized Plant</text>
        <text x={220} y={142} textAnchor="middle" fontSize="9" fill={BLUE}>(includes weights)</text>

        {/* K block */}
        <rect x={130} y={210} width={180} height={44} rx={5} fill={LTRED} stroke={RED} strokeWidth="2"/>
        <text x={220} y={237} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">K(s)</text>
        <text x={220} y={251} textAnchor="middle" fontSize="9.5" fill={RED}>Controller (to design)</text>

        {/* Signals */}
        <Arr x1={14} y1={80} x2={130} y2={80} color={ORANGE} marker="aOrange" lbl="w (disturbances)" lx={72} ly={72}/>
        <Arr x1={310} y1={80} x2={420} y2={80} color={GREEN} marker="aGreen" lbl="z (errors)" lx={362} ly={72}/>
        <Arr x1={310} y1={140} x2={420} y2={140} color={BLUE} marker="aBlue" lbl="y (measurements)" lx={362} ly={132}/>
        <line x1={420} y1={140} x2={420} y2={232} stroke={BLUE} strokeWidth="1.8"/>
        <Arr x1={420} y1={232} x2={310} y2={232} color={BLUE} marker="aBlue"/>
        <Arr x1={130} y1={232} x2={30} y2={232} color={RED} marker="aRed" lbl="u (control)" lx={80} ly={224}/>
        <line x1={30} y1={232} x2={30} y2={80} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={30} y1={80} x2={130} y2={80} color={RED} marker="aRed"/>

        {/* H-inf objective */}
        <rect x={14} y={278} width={408} height={80} rx={4} fill={LTRED} stroke={RED} strokeWidth="1.5"/>
        <text x={218} y={296} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700">H-infinity design objective:</text>
        <text x={218} y={313} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700" fontFamily="'Courier New',monospace">||T_zw(s)||_inf &lt; gamma</text>
        <text x={218} y={330} textAnchor="middle" fontSize="10" fill="#555">T_zw: closed-loop transfer function from w to z</text>
        <text x={218} y={346} textAnchor="middle" fontSize="10" fill="#555">||.||_inf = peak of singular value plot over all frequencies</text>

        {/* Right: sensitivity functions and weights */}
        <rect x={455} y={10} width={435} height={350} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={672} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Weighted Sensitivity Design</text>

        {[
          { y:36, color:RED,    bg:LTRED, lines:[
            'Sensitivity S(s) = 1/(1+GK)',
            'Maps disturbance d -> output e',
            'W1 * S: weight for tracking/disturbance rejection',
            'Make W1*S small at low frequencies (good tracking)',
          ]},
          { y:106, color:BLUE, bg:LTBLU, lines:[
            'Complementary sensitivity T(s) = GK/(1+GK)',
            'Maps noise n -> output y',
            'W2 * T: weight for noise/robustness',
            'S + T = 1: waterbed effect (cannot improve both)',
          ]},
          { y:176, color:GREEN, bg:LTGRN, lines:[
            'Control sensitivity KS(s) = K/(1+GK)',
            'Maps disturbance d -> control u',
            'W3 * KS: limits control effort (actuator constraint)',
            'Prevents K from being too large (noise amplification)',
          ]},
          { y:246, color:ORANGE, bg:LTORG, lines:[
            'Mixed sensitivity problem',
            'min_K || [W1*S; W3*KS] ||_inf',
            'Solved via Riccati equations (gamma-iteration)',
            'MATLAB: hinfsyn(P, ny, nu)  or  mixsyn(G, W1, W2, W3)',
          ]},
          { y:310, color:PURPLE, bg:LTPUR, lines:[
            'Bode gain-phase intuition',
            'W1^(-1): performance bound (loop gain must exceed at low freq)',
            'W2^(-1): robustness bound (loop gain must fall below at high freq)',
            'Roll-off of W2 prevents gain from staying high into noise region',
          ]},
        ].map(({ y, color, bg, lines }) => (
          <Card key={y} x={463} y={y} w={419} h={58} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        H-infinity design finds a controller K(s) that minimises the H-infinity norm of the closed-loop transfer function from disturbance inputs w to error outputs z. The norm equals the peak gain over all frequencies and all directions -- it is the worst-case amplification. By choosing the weighting functions W1, W2, W3 appropriately, the designer encodes frequency-domain specifications: W1 shapes the sensitivity for tracking, W2 shapes noise rejection, W3 limits control effort.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 8 -- Uncertainty models and mu-synthesis
// =================================================================
function DiagramUncertainty() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Uncertainty Models and mu-Synthesis -- Structured Singular Value</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Three uncertainty types */}
        {[
          { x:10,  title:'Additive Uncertainty',    color:BLUE,   bg:LTBLU,
            eq:   'G_true(s) = G(s) + Delta_a(s)',
            weight:'W_a(s)',
            norm: '||Delta_a||_inf &lt;= 1',
            desc: 'Models uncertain dynamics added to nominal plant',
            use:  'Absolute bound on model error; unstructured' },
          { x:310, title:'Multiplicative Uncertainty', color:ORANGE, bg:LTORG,
            eq:   'G_true(s) = G(s)*(1 + W_m*Delta_m)',
            weight:'W_m(s)',
            norm: '||Delta_m||_inf &lt;= 1',
            desc: 'Relative/percentage uncertainty in gain and phase',
            use:  'Common: percent error grows at high frequency' },
          { x:610, title:'Parametric Uncertainty', color:PURPLE, bg:LTPUR,
            eq:   'G(s,p) where p in [p_min, p_max]',
            weight:'Real Delta block',
            norm: '|delta_i| &lt;= 1 for each parameter',
            desc: 'Known structure but unknown coefficient values',
            use:  'mu-analysis; structured real uncertainty' },
        ].map(({ x, title, color, bg, eq, weight, norm, desc, use }) => (
          <g key={x}>
            <rect x={x} y={10} width={280} height={220} rx={5} fill="#fff" stroke={BORDER}/>
            <rect x={x} y={10} width={280} height={34} rx={5} fill={color} opacity="0.12"/>
            <text x={x+140} y={33} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{title}</text>
            <rect x={x+8} y={50} width={264} height={36} rx={3} fill={bg} stroke={color} strokeWidth="1.5"/>
            <text x={x+140} y={66} textAnchor="middle" fontSize="10.5" fill={color} fontWeight="700" fontFamily="'Courier New',monospace">{eq}</text>
            <text x={x+140} y={80} textAnchor="middle" fontSize="9" fill="#555">{weight},  {norm}</text>
            <text x={x+14} y={104} fontSize="9.5" fill="#333">{desc}</text>
            <text x={x+14} y={120} fontSize="9.5" fill="#333">{use}</text>

            {/* Mini Bode plot showing uncertainty region */}
            {(() => {
              const bx2=x+12, by2=132, bw2=256, bh2=80;
              const freqs = [0,0.2,0.4,0.6,0.8,1.0];
              const nomGain = freqs.map(f => 20 - f*30);
              const uncBound = freqs.map((f, i) => nomGain[i] + (x===310 ? 5+f*15 : 5));

              return (
                <g>
                  <rect x={bx2} y={by2} width={bw2} height={bh2} rx={3} fill="#fafafa" stroke="#eee"/>
                  {/* Nominal gain */}
                  <polyline points={nomGain.map((v,i) => (bx2+i*bw2/5)+','+(by2+bh2/2-v*bh2*0.025)).join(' ')}
                    fill="none" stroke={color} strokeWidth="2"/>
                  {/* Uncertainty bound */}
                  <polyline points={uncBound.map((v,i) => (bx2+i*bw2/5)+','+(by2+bh2/2-v*bh2*0.025)).join(' ')}
                    fill="none" stroke={color} strokeWidth="1.2" strokeDasharray="4 2" opacity="0.6"/>
                  <text x={bx2+bw2/2} y={by2+bh2+14} textAnchor="middle" fontSize="8.5" fill="#aaa">frequency</text>
                  <text x={bx2+4} y={by2+12} fontSize="8" fill={color}>|G| with uncertainty</text>
                </g>
              );
            })()}
          </g>
        ))}

        {/* mu-synthesis */}
        <rect x={10} y={238} width={880} height={112} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={256} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">mu-Synthesis -- Handling Structured Uncertainty</text>

        {[
          { x:18,  color:RED,    bg:LTRED,  lines:['Structured singular value mu','mu_Delta(M) = 1 / min{ sigma_bar(Delta) : det(I-M*Delta)=0 }','Measures worst-case gain for STRUCTURED Delta'] },
          { x:248, color:BLUE,   bg:LTBLU,  lines:['D-K iteration','Alternately: fix K, optimise D scaling; fix D, optimise K','Converges to mu-optimal controller (not guaranteed global opt)'] },
          { x:478, color:GREEN,  bg:LTGRN,  lines:['Robust stability condition','System robustly stable iff mu_Delta(M_11) &lt; 1 for all omega','M_11: lower LFT of P and K; mu computed per frequency'] },
          { x:700, color:ORANGE, bg:LTORG,  lines:['mu vs H-inf','H-inf: unstructured Delta (conservative)','mu: exploits structure of Delta (less conservative)'] },
        ].map(({ x, color, bg, lines }) => (
          <Card key={x} x={x} y={264} w={222} h={78} bg={bg} bc={color} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        Robust control requires a model of what is unknown. Additive uncertainty models absolute error; multiplicative uncertainty models percentage error (typical: small at low frequencies, growing at high frequencies due to unmodelled dynamics). Parametric uncertainty models known-structure but unknown-value parameters. H-infinity handles unstructured uncertainty conservatively; mu-synthesis exploits the known structure of the uncertainty to produce less conservative designs via D-K iteration.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 9 -- Robust stability and performance regions
// =================================================================
function DiagramRobustRegion() {
  const W = 900, H = 350;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Robust Stability and Robust Performance -- Bode and Nyquist Interpretation</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: Bode magnitude with uncertainty band */}
        <rect x={10} y={10} width={410} height={330} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={215} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Loop Gain Bode Plot -- Performance and Stability Bounds</text>

        {(() => {
          const bx=22, by=38, bw=386, bh=270;
          const freqs = Array.from({length:80}, (_,k) => k*3/79);
          const toX=f=>(bx+f/3*bw);
          const toY=v=>(by+bh/2-v*bh*0.15);

          // Nominal loop gain L(jw) = GK
          const Lnom = freqs.map(f => 20*Math.log10(Math.max(0.001, 10/(1+f*2)/(1+f*0.5))));
          // Upper/lower bounds
          const Lupp = Lnom.map(v => v + 4);
          const Llow = Lnom.map(v => v - 6);

          // Performance weight (lower bound at low freq)
          const Wperf = freqs.map(f => 20*Math.log10(Math.max(0.001, 0.5/(0.01+f))));
          // Robustness weight (upper bound at high freq)
          const Wrob  = freqs.map(f => 20*Math.log10(Math.max(0.001, 2/(1+f*0.3))));

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              {[-40,-20,0,20,40].map(v => (
                <g key={v}>
                  <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke={Math.abs(v)<1?'#bbb':'#f0f0f0'} strokeWidth={Math.abs(v)<1?1.3:1}/>
                  <text x={bx-4} y={toY(v)+4} textAnchor="end" fontSize="8" fill="#ccc">{v}</text>
                </g>
              ))}

              {/* Uncertainty band */}
              <polygon
                points={[...Lupp.map((v,i)=>toX(freqs[i])+','+toY(v)), ...[...Llow].reverse().map((v,i)=>toX(freqs[79-i])+','+toY(v))].join(' ')}
                fill={BLUE} opacity="0.1"/>

              {/* Performance bound (must stay above) */}
              <polyline points={Wperf.map((v,f)=>toX(freqs[f])+','+toY(v)).join(' ')}
                fill="none" stroke={GREEN} strokeWidth="1.5" strokeDasharray="6 3"/>
              {/* Robustness bound (must fall below) */}
              <polyline points={Wrob.map((v,f)=>toX(freqs[f])+','+toY(v)).join(' ')}
                fill="none" stroke={RED} strokeWidth="1.5" strokeDasharray="6 3"/>

              {/* Nominal loop gain */}
              <polyline points={Lnom.map((v,i)=>toX(freqs[i])+','+toY(v)).join(' ')}
                fill="none" stroke={BLUE} strokeWidth="2.5"/>

              {/* Labels */}
              <text x={bx+8} y={toY(25)-6} fontSize="9" fill={GREEN} fontWeight="700">1/W1 (performance bound)</text>
              <text x={bx+8} y={toY(8)+14} fontSize="9" fill={RED} fontWeight="700">1/W2 (robustness bound)</text>
              <text x={bx+bw/2} y={toY(-2)-6} fontSize="9" fill={BLUE} fontWeight="700">L(jw) nominal</text>
              <text x={bx+bw/2} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#777">frequency (rad/s)</text>

              {/* 0dB line label */}
              <text x={bx+bw-4} y={toY(0)-3} textAnchor="end" fontSize="9" fill="#888">0 dB</text>

              {/* Crossover annotation */}
              {(() => {
                const idx = Lnom.findIndex(v => v < 0);
                if (idx>0) {
                  const f0 = freqs[idx];
                  return (
                    <g>
                      <line x1={toX(f0)} y1={by} x2={toX(f0)} y2={by+bh} stroke={ORANGE} strokeWidth="1.5" strokeDasharray="4 2" opacity="0.7"/>
                      <text x={toX(f0)+3} y={by+14} fontSize="8" fill={ORANGE}>crossover</text>
                    </g>
                  );
                }
                return null;
              })()}
            </g>
          );
        })()}

        {/* Right: Nyquist uncertainty disk */}
        <rect x={435} y={10} width={455} height={330} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={662} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Nyquist -- Robust Stability Region</text>

        {(() => {
          const cx=600, cy=170, sc=80;
          const toXn=r=>cx+r*sc, toYn=i=>cy-i*sc;

          // Nominal Nyquist curve
          const nPts = Array.from({length:60}, (_,k) => {
            const w = k*4/59;
            const re = 10/(1+w*2)/(1+w*0.5) * Math.cos(-Math.atan(2*w)-Math.atan(0.5*w));
            const im = 10/(1+w*2)/(1+w*0.5) * Math.sin(-Math.atan(2*w)-Math.atan(0.5*w));
            return [re, im];
          });

          // Uncertainty disk at phase crossover
          const pcIdx = 40;
          const [re0, im0] = nPts[pcIdx] || [0, 0];
          const diskR = 0.2;

          return (
            <g>
              {/* Plot area */}
              <rect x={445} y={36} width={435} height={280} rx={3} fill="#fafafa" stroke="#eee"/>
              {[-2,-1,0,1,2].map(v => (
                <g key={'nx'+v}>
                  <line x1={toXn(v)} y1={36} x2={toXn(v)} y2={316} stroke="#f0f0f0" strokeWidth="1"/>
                  {v!==0 && <text x={toXn(v)} y={320} textAnchor="middle" fontSize="8" fill="#ccc">{v}</text>}
                </g>
              ))}
              {[-1,0,1].map(v => (
                <g key={'ny'+v}>
                  <line x1={445} y1={toYn(v)} x2={880} y2={toYn(v)} stroke="#f0f0f0" strokeWidth="1"/>
                  {v!==0 && <text x={441} y={toYn(v)+4} textAnchor="end" fontSize="8" fill="#ccc">{v>0?'+'+v+'j':v+'j'}</text>}
                </g>
              ))}

              {/* Axes */}
              <line x1={445} y1={cy} x2={880} y2={cy} stroke="#ccc" strokeWidth="1.2"/>
              <line x1={cx} y1={36} x2={cx} y2={316} stroke="#ccc" strokeWidth="1.2"/>

              {/* Critical point */}
              <circle cx={toXn(-1)} cy={toYn(0)} r={8} fill="none" stroke={RED} strokeWidth="2"/>
              <circle cx={toXn(-1)} cy={toYn(0)} r={3} fill={RED}/>
              <text x={toXn(-1)+10} y={toYn(0)-8} fontSize="9" fill={RED} fontWeight="700">(-1,0)</text>

              {/* Nominal Nyquist */}
              <polyline points={nPts.map(([r,i]) => toXn(r)+','+toYn(i)).join(' ')}
                fill="none" stroke={BLUE} strokeWidth="2"/>

              {/* Uncertainty disks at a few points */}
              {[15, 30, 45].map(idx => {
                const [r,i] = nPts[idx] || [0,0];
                const dr = 0.12 + idx * 0.005;
                return (
                  <circle key={'ud'+idx} cx={toXn(r)} cy={toYn(i)} r={dr*sc}
                    fill={ORANGE} opacity="0.15" stroke={ORANGE} strokeWidth="1" strokeDasharray="3 2"/>
                );
              })}

              <text x={toXn(0.5)} y={toYn(-0.8)} fontSize="9" fill={ORANGE}>uncertainty disks</text>
              <text x={toXn(0.5)} y={toYn(-0.95)} fontSize="8" fill={ORANGE}>(grow at high freq)</text>

              {/* Stability margin */}
              <line x1={toXn(-1)} y1={toYn(0)} x2={toXn(nPts[50]?nPts[50][0]:0)} y2={toYn(nPts[50]?nPts[50][1]:0)}
                stroke={GREEN} strokeWidth="1.5" strokeDasharray="3 2"/>
              <text x={560} y={260} fontSize="9" fill={GREEN}>distance to (-1,0)</text>
              <text x={560} y={272} fontSize="8" fill={GREEN}>= stability margin</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>
        Robust stability requires the loop gain L(jw) to remain within bounds at all frequencies for all plants in the uncertainty set. In the Bode plot, the loop gain must exceed the performance weight (1/W1) at low frequencies and fall below the robustness weight (1/W2) at high frequencies -- the classic waterbed constraint. In the Nyquist plot, the uncertainty disks (growing at high frequency due to unmodelled dynamics) must never engulf the critical point (-1,0).
      </div>
    </div>
  );
}

// =================================================================
// Diagram 10 -- Comparison table and method selection guide
// =================================================================
function DiagramMethodComparison() {
  const W = 900, H = 380;
  const methods = [
    { name:'PID (fixed)',    color:TEAL   },
    { name:'Gain Scheduling',color:BLUE   },
    { name:'MRAC',           color:GREEN  },
    { name:'Self-Tuning (RLS)',color:PURPLE},
    { name:'Sliding Mode',   color:ORANGE },
    { name:'H-infinity',     color:RED    },
    { name:'mu-synthesis',   color:DKRED  },
  ];
  const attrs = [
    { name:'Handles uncertainty',
      vals:['Fixed margins only','Pre-computed table','Yes - online adapt.','Yes - identifies params','Yes - bounds on dist.','Yes - worst-case gain','Yes - structured unc.'] },
    { name:'Constraint handling',
      vals:['Saturation only','Saturation + scheduling','No hard constraints','No hard constraints','Yes (natural barrier)','Implicit (penalty)','Implicit (penalty)'] },
    { name:'Stability guarantee',
      vals:['If margins ok','At design points','Lyapunov (some cases)','Lyapunov + PE','Lyapunov (reaching)','Guaranteed (H-inf)','Guaranteed (mu)'] },
    { name:'Online computation',
      vals:['Trivial','Table lookup','Low (update laws)','Moderate (RLS)','Low (switching)','None (fixed K)','None (fixed K)'] },
    { name:'Model required',
      vals:['Transfer function','Family of LTI models','Reference model + G','Regressor structure','Nonlinear + bounds','Nominal G + weights','Nominal G + Delta'] },
    { name:'Typical domain',
      vals:['All industries','Aerospace, auto','Robotics, flight','Chemical, process','Power electronics','Aerospace, mfg','High-perf. systems'] },
  ];
  const colW = 108, rowH = 46, hdrH = 36;
  const nameW = 150;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Method Comparison -- Adaptive and Robust Control Strategies</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>
        {/* Column headers */}
        <rect x={10} y={10} width={nameW} height={hdrH} fill={DKRED} rx={3}/>
        <text x={10+nameW/2} y={10+hdrH/2+5} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Attribute</text>
        {methods.map(({ name, color }, ci) => (
          <g key={ci}>
            <rect x={10+nameW+ci*colW} y={10} width={colW} height={hdrH} fill={color} opacity="0.15" stroke={color} strokeWidth="1" rx={ci===0?0:0}/>
            <text x={10+nameW+ci*colW+colW/2} y={28} textAnchor="middle" fontSize="9.5" fill={color} fontWeight="700">{name.split(' ')[0]}</text>
            <text x={10+nameW+ci*colW+colW/2} y={42} textAnchor="middle" fontSize="9" fill={color}>{name.split(' ').slice(1).join(' ')}</text>
          </g>
        ))}
        {/* Rows */}
        {attrs.map(({ name, vals }, ri) => {
          const bg = ri%2===0 ? '#fafafa' : '#fff';
          const y = 10 + hdrH + ri * rowH;
          return (
            <g key={ri}>
              <rect x={10} y={y} width={nameW} height={rowH} fill={DKRED} opacity="0.07" stroke="#f0cece" strokeWidth="0.5"/>
              <text x={16} y={y+rowH/2+4} fontSize="10" fill={DKRED} fontWeight="700">{name}</text>
              {vals.map((val, ci) => (
                <g key={ci}>
                  <rect x={10+nameW+ci*colW} y={y} width={colW} height={rowH} fill={bg} stroke="#f0f0f0" strokeWidth="0.5"/>
                  <text x={10+nameW+ci*colW+4} y={y+15} fontSize="8.5" fill="#333">{val.slice(0,18)}</text>
                  {val.length > 18 && <text x={10+nameW+ci*colW+4} y={y+27} fontSize="8.5" fill="#333">{val.slice(18,36)}</text>}
                  {val.length > 36 && <text x={10+nameW+ci*colW+4} y={y+39} fontSize="8.5" fill="#333">{val.slice(36)}</text>}
                </g>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        Method selection depends on the type of uncertainty, available computation, and required stability guarantees. Gain scheduling is simplest for slowly varying operating conditions. MRAC and RLS provide online adaptation for unknown parameters. Sliding mode offers robustness to bounded disturbances with simple analysis. H-infinity and mu-synthesis provide rigorous frequency-domain guarantees for linear uncertainty models. MPC (not shown) can combine constraint handling with robustness via robust or stochastic MPC formulations.
      </div>
    </div>
  );
}

// =================================================================
// Main
// =================================================================
export default function AdaptiveRobustControl() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Adaptive and Robust Control</h1>
      <p style={S.p}>
        Classical control design assumes the plant is perfectly known -- but real systems have uncertain masses, temperatures that drift, components that age, and dynamics that shift with operating condition. Adaptive control responds to this challenge by continuously measuring and learning: it identifies the unknown parameters online and updates the controller gains to compensate. Robust control takes a different stance: it accepts that uncertainty will always exist within some bounded set, and designs a single fixed controller that is guaranteed to work for every plant in that set. Both approaches are essential tools, and modern systems often combine them.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Adaptive: controller gains change online to compensate for unknown/drifting parameters",
        "Robust: fixed gains designed to tolerate worst-case uncertainty within a bounded set",
        "Gain scheduling: pre-compute gains at operating points; interpolate using measured schedule variable",
        "MRAC: adjust gains to make plant output track a reference model output; MIT rule or Lyapunov",
        "RLS: recursive least squares identifies unknown plant parameters online; forgetting factor tracks drift",
        "Sliding mode: force state onto a designed surface; immune to bounded disturbances while sliding",
        "H-infinity: minimise peak gain from disturbance to error; ||Tzw||_inf &lt; gamma via Riccati equations",
        "mu-synthesis: handle structured uncertainty via structured singular value; D-K iteration",
        "PE (persistent excitation): input must excite all modes for parameter identification to converge",
      ]}/>

      <h2 style={S.h2}>Adaptive vs Robust: The Two Philosophies</h2>
      <p style={S.p}>
        Before choosing a design method, it is important to understand the fundamental trade-off between adaptive and robust approaches. Adaptive control assumes the uncertainty is learnable: if given enough time and the right signals, the controller can identify the true plant parameters and achieve near-optimal performance. Robust control assumes the uncertainty is bounded but unknowable: the set of possible plants is specified upfront, and the controller must work for every member of that set simultaneously.
      </p>
      <DiagramPhilosophy/>
      <Table2 rows={[
        ["When to use adaptive","Plant parameters drift slowly (aging, temperature changes)\nInitial model is poor but structure is known; online learning is feasible"],
        ["When to use robust","Uncertainty bounds are known; fast dynamics make adaptation dangerous\nSafety-critical: need formal guarantee, not probabilistic convergence"],
        ["Stability: adaptive","Harder to prove -- depends on adaptation law and signal richness\nLyapunov methods provide stability under persistent excitation conditions"],
        ["Stability: robust","Formal guarantee: H-inf norm condition, mu condition, or Lyapunov with uncertainty bounds\nGuaranteed for all plants in the uncertainty set simultaneously"],
        ["Combined approach","Adaptive robustness: combine parameter identification with worst-case design\ne.g., gain-scheduled H-inf, robust MPC, self-tuning PID with uncertainty margins"],
        ["Practical tip","Start with robust (guaranteed); add adaptation if performance is insufficient\nNever deploy adaptive control without fallback stability mechanism"],
      ]}/>

      <h2 style={S.h2}>Gain Scheduling</h2>
      <p style={S.p}>
        Gain scheduling is the oldest and most widely used form of adaptive control. The plant is linearised at multiple operating points, a linear controller (PID, LQR, pole placement) is designed at each point, and the resulting gains are stored in a lookup table. At runtime, a measurable scheduling variable (speed, altitude, temperature) selects or interpolates between the pre-computed gains.
      </p>
      <DiagramGainScheduling/>
      <Table2 rows={[
        ["Design procedure","Identify operating points; linearise at each; design linear K_i at each point\nStore [rho_i, K_i] pairs; implement smooth interpolation"],
        ["Scheduling variable","Any measurable signal correlated with plant dynamics\nExamples: Mach number (aircraft), throttle position (engine), temperature (reactor)"],
        ["Linear Parameter Varying (LPV)","Rigorous extension: x_dot = A(rho)*x + B(rho)*u\nSynthesise single gain-scheduled K(rho) with stability guarantee across rho range"],
        ["Stability concern","Gains change in time: d/dt[K(rho(t))] adds a derivative term not in linear analysis\nFast-varying rho can destabilise even if K_i is stable at each point"],
        ["Anti-windup for scheduling","Integrator state must be reset/transitioned when gains change\nMismatch in integrator state causes transient spikes on switching"],
        ["MATLAB","MATLAB Robust Control Toolbox: lpvss(), lpvsyn() for LPV synthesis\nSimulink: use Varying Coefficients block or lookup table with interpolation"],
      ]}/>

      <h2 style={S.h2}>Model Reference Adaptive Control (MRAC)</h2>
      <p style={S.p}>
        MRAC specifies the desired closed-loop behaviour through a reference model Gm(s) -- typically a well-damped second-order system. The adaptation law continuously adjusts the controller parameters so that the actual plant output tracks the reference model output. The error between the two drives the parameter updates via either the MIT rule or a Lyapunov-based design.
      </p>
      <DiagramMRAC/>
      <Table2 rows={[
        ["Reference model Gm(s)","Specifies desired behaviour: bandwidth, damping, settling time\nTypically: Gm(s) = wn^2 / (s^2 + 2*zeta*wn*s + wn^2)"],
        ["Tracking error","e(t) = yp(t) - ym(t): plant output minus reference model output\nGoal: e(t) -> 0 as t -> infinity"],
        ["MIT rule","d(theta)/dt = -gamma * e * phi; phi = sensitivity partial(e)/partial(theta)\nSimple but may be unstable for large gamma or non-PE input"],
        ["Lyapunov-based MRAC","Design adaptation law to ensure V(e, theta_tilde) = e^T P e + theta_tilde^T theta_tilde decreases\nProvides stability proof; standard for rigorous designs"],
        ["Persistent excitation","Input r(t) must excite all plant modes for theta to converge to truth\nWithout PE: e -> 0 but theta may not converge (parameter drift possible)"],
        ["Stability caveat","Global stability requires PE + bounded disturbances + correct relative degree\nBursting instability: slowly drifting parameters can cause large transients"],
      ]}/>

      <h2 style={S.h2}>MIT Rule and Parameter Adaptation</h2>
      <p style={S.p}>
        The MIT rule is the simplest practical adaptation law: it performs gradient descent on the squared tracking error with respect to the controller parameters. The sensitivity signal phi = partial(e)/partial(theta) tells the adaptation law which direction to adjust theta to reduce the error. The adaptation gain gamma controls the trade-off between convergence speed and stability.
      </p>
      <DiagramMITRule/>
      <Table2 rows={[
        ["MIT rule formula","d(theta)/dt = -gamma * e * phi\ngamma: adaptation gain; phi: sensitivity; e: tracking error"],
        ["Sensitivity computation","phi = partial(e)/partial(theta) = partial(yp)/partial(theta) (approximately)\nFor simple model-following: phi = reference model output Gm(s)*r"],
        ["Stability of MIT rule","NOT guaranteed for all gamma -- can oscillate for large gamma\nNormalized MIT rule: d(theta)/dt = -gamma * e * phi / (1 + phi^T*phi) is more stable"],
        ["Lyapunov improvement","Choose V = (1/2)*gamma^{-1}*theta_tilde^T*theta_tilde + (1/2)*e^T*P*e\nDesign adaptation to make V_dot &lt;= -alpha*e^T*e (negative definite)"],
        ["Projection algorithm","Constrain theta to known bounded set: theta_min &lt;= theta &lt;= theta_max\nPrevents parameter drift and bursting; standard robustness addition"],
        ["Sigma modification","Add damping: d(theta)/dt = -gamma*(e*phi + sigma*theta)\nSigma > 0 stabilises against disturbances; small sigma loss of exact convergence"],
      ]}/>

      <h2 style={S.h2}>Recursive Least Squares and Self-Tuning Control</h2>
      <p style={S.p}>
        Recursive Least Squares (RLS) provides a systematic way to identify unknown plant parameters online. Combined with a controller design algorithm (pole placement, minimum variance), it forms a self-tuning regulator (STR): the plant model is identified from input-output data, and the controller is redesigned based on the latest estimates. The forgetting factor allows tracking of slowly time-varying parameters.
      </p>
      <DiagramRLS/>
      <Table2 rows={[
        ["RLS model structure","y(k) = phi(k)^T * theta, phi = [-y(k-1),...,-y(k-n), u(k-1),...,u(k-m)]^T\nARX model: A(z)*y = B(z)*u; identifies A and B polynomial coefficients online"],
        ["Forgetting factor lambda","lambda = 1: standard batch LS (equal weight to all data)\nlambda = 0.95: data more than 20 steps old has weight < 37%"],
        ["Covariance blowup","With lambda < 1 and PE lost: P grows unbounded (estimator windup)\nFix: directional forgetting, variable forgetting, or covariance resetting"],
        ["Self-tuning regulator","Step 1: identify theta via RLS; Step 2: design K from theta; repeat\nIndirect (identify then design) vs direct (directly identify controller params)"],
        ["Minimum variance control","Indirect STR: identify model, compute MV controller\nMinimises E[y(k)^2]; optimal for ARMAX noise; may give poor step response"],
        ["Convergence conditions","PE of order n: input must persistently excite all n plant modes\nFor PRBS input: guaranteed PE; for step: only DC gain identified"],
      ]}/>

      <h2 style={S.h2}>Sliding Mode Control</h2>
      <p style={S.p}>
        Sliding Mode Control is a robust nonlinear technique that drives the system state onto a designer-specified surface and then constrains it to slide along that surface toward the equilibrium. Once on the surface, the dynamics are completely determined by the surface design and are insensitive to bounded disturbances and parameter uncertainty -- a powerful robustness property.
      </p>
      <DiagramSlidingMode/>
      <Table2 rows={[
        ["Sliding surface design","s(x) = c^T * e + e_dot for 2nd order; c sets closed-loop bandwidth\nWhen s=0, e_dot = -c*e: error decays with time constant 1/c"],
        ["Reaching condition","s * s_dot &lt;= -eta * |s| for some eta &gt; 0\nGuarantees trajectories reach s=0 in finite time"],
        ["Discontinuous control","u = u_eq - k * sign(s); k &gt; |disturbance_bound|\nu_eq: equivalent control that would maintain s=0 without uncertainty"],
        ["Chattering and mitigation","Sign function causes high-frequency switching (chattering)\nBoundary layer: replace sign(s) with s/(|s|+phi) or sat(s/phi)"],
        ["Higher-order SMC","Super-twisting algorithm: continuous u, differentiates to get sign in s_dot\nEliminates chattering while maintaining full robustness"],
        ["Robustness property","On sliding surface: dynamics exact regardless of parameter variations\nRequires only bound on disturbance magnitude, not exact model"],
      ]}/>

      <h2 style={S.h2}>H-infinity Robust Control</h2>
      <p style={S.p}>
        H-infinity design formulates robust control as a minimax problem: find the controller K that minimises the worst-case gain from exogenous inputs (disturbances, noise, references) to regulated outputs (errors, states, control signals). The H-infinity norm equals the peak singular value of the transfer matrix over all frequencies -- minimising it ensures the closed-loop system amplifies disturbances as little as possible in the worst case.
      </p>
      <DiagramHInfinity/>
      <Table2 rows={[
        ["H-infinity norm","||T_zw||_inf = sup_w sigma_bar(T_zw(jw)) = worst-case gain from w to z\nFinite norm iff T_zw has no imaginary-axis poles"],
        ["Standard P-K form","P(s): generalized plant including weights W1, W2, W3\nK(s): controller to be designed; minimize ||LFT(P,K)||_inf"],
        ["Sensitivity weighting W1","W1(s) chosen so 1/W1 is upper bound on acceptable |S(jw)|\nTypical: W1 = (s/M + wb)/(s + wb*eps); wb: bandwidth, M: peak sensitivity"],
        ["Complementary sensitivity W2","W2(s) chosen so 1/W2 lower bounds allowable gain at high frequency\nGrows with frequency: captures unmodelled high-frequency dynamics"],
        ["Riccati solution","H-inf controller found via two algebraic Riccati equations (suboptimal)\nX_inf, Y_inf from AREinf; controller is strictly proper order-n"],
        ["MATLAB","P = augw(G, W1, W2, W3); [K, CL, gam] = hinfsyn(P, 1, 1)\nOr: hinfstruct for structured controllers"],
      ]}/>

      <h2 style={S.h2}>Uncertainty Models and mu-Synthesis</h2>
      <p style={S.p}>
        H-infinity treats all uncertainty as unstructured (a dense complex matrix Delta), which can be overly conservative when the uncertainty has known structure -- e.g., only certain parameters are uncertain, or uncertainty is real-valued (parametric). The structured singular value mu exploits this known structure to give tighter (less conservative) robustness guarantees, computed via D-K iteration.
      </p>
      <DiagramUncertainty/>
      <Table2 rows={[
        ["Additive uncertainty","G_true = G + W_a * Delta; ||Delta||_inf &lt;= 1\nRobust stability: ||W_a * K * (I+GK)^(-1)||_inf &lt; 1"],
        ["Multiplicative uncertainty","G_true = G * (I + W_m * Delta); ||Delta||_inf &lt;= 1\nRobust stability: ||W_m * T(s)||_inf &lt; 1; T = GK/(1+GK)"],
        ["Parametric uncertainty","p in [p_nom - delta_p, p_nom + delta_p]: real scalar uncertainty\nHandled by mu with real Delta blocks; H-inf (complex Delta) is conservative here"],
        ["Structured singular value mu","mu_Delta(M) = 1/min{sigma_bar(Delta): det(I - M*Delta)=0, Delta in structure}\nmu = 1/max structured destabilising Delta magnitude"],
        ["Robust performance condition","Robust stability AND nominal performance together: mu condition\nmu_Delta_bar(M(jw)) &lt; 1 for all w (Delta_bar includes performance block)"],
        ["D-K iteration","Step 1: fix K, optimise D scalings to minimise mu upper bound\nStep 2: fix D, solve H-inf with scaled plant D*P*D^(-1); repeat"],
      ]}/>

      <h2 style={S.h2}>Robust Stability and Performance Regions</h2>
      <p style={S.p}>
        The Bode and Nyquist plots provide geometric insight into robust stability. In the Bode plot, the loop gain must stay within two bounds: above the performance weight at low frequencies (tracking) and below the robustness weight at high frequencies (noise rejection and unmodelled dynamics). These two constraints create the fundamental waterbed limitation -- making the loop gain high everywhere simultaneously is impossible.
      </p>
      <DiagramRobustRegion/>
      <Table2 rows={[
        ["Waterbed effect","S + T = 1: cannot make both S and T small at the same frequency\nReducing S at low frequencies forces T to be large somewhere (or vice versa)"],
        ["Bode gain-phase","Must exceed 1/W1 at low freq (performance) and fall below 1/W2 at high freq (robustness)\nCrossover region: finite slope (-20 dB/dec) needed to satisfy both simultaneously"],
        ["Gain and phase margins","GM and PM are lower bounds on how close the Nyquist curve comes to (-1,0)\nH-inf design can guarantee specific GM and PM via appropriate weighting"],
        ["Robust stability (additive)","||W_a * K * S||_inf &lt; 1; equivalent to: uncertainty disk never touches Nyquist (-1,0)\nLarger uncertainty disk requires larger clearance from critical point"],
        ["Robust stability (multiplicative)","||W_m * T||_inf &lt; 1; loop gain must roll off before uncertainty dominates\nT small at high freq: both noise rejection and robustness requirement"],
        ["Small gain theorem","||M_1|| * ||M_2|| &lt; 1 implies stability of M_1-M_2 feedback loop\nFoundation for most robust stability conditions; H-inf norm is the relevant norm"],
      ]}/>

      <h2 style={S.h2}>Method Comparison and Selection Guide</h2>
      <p style={S.p}>
        Choosing between adaptive and robust methods requires understanding the nature of the uncertainty, available computation, and required guarantees. The comparison table below highlights the key distinctions. In practice, many industrial systems use gain scheduling as the primary adaptive mechanism (simple, proven) combined with H-infinity design at each operating point (robust against unmodelled dynamics and sensor noise).
      </p>
      <DiagramMethodComparison/>
      <Table2 rows={[
        ["Fixed gains (PID/LQR)","Simplest; appropriate when plant is well-known and stable\nNo adaptation or robustness analysis needed for well-designed classical loops"],
        ["Gain scheduling","When plant varies smoothly with measurable signal; common first choice\nProvides adaptation without online computation; stability gap at transitions"],
        ["MRAC / RLS","When parameters drift slowly and PE can be maintained\nRequires signal richness; unstable during adaptation if not carefully designed"],
        ["Sliding mode","When nonlinear plant with bounded disturbances; fast switching hardware\nStrong robustness; chattering must be mitigated for smooth actuators"],
        ["H-infinity","When frequency-domain performance specs are natural; linear uncertain plant\nSystematic; conservative if uncertainty is structured (use mu-synthesis instead)"],
        ["mu-synthesis","When uncertainty has known structure (parametric or block-diagonal)\nLess conservative than H-inf; requires structured uncertainty model"],
        ["Combined strategies","Gain-scheduled H-inf: K(rho) designed via H-inf at each operating point\nAdaptive robust: RLS + H-inf; robust MPC: MPC with explicit uncertainty sets"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "MIT rule: d(theta)/dt = -gamma * e * phi  where  phi = partial(e)/partial(theta)",
        "Lyapunov MRAC: choose V = e^T P e + gamma^(-1) * theta_tilde^T * theta_tilde; ensure V_dot &lt;= 0",
        "RLS update: theta(k) = theta(k-1) + L(k) * (y(k) - phi(k)^T * theta(k-1))",
        "RLS gain: L(k) = P(k-1)*phi(k) / (lambda + phi(k)^T * P(k-1) * phi(k))",
        "Sliding mode: u = u_eq - k*sign(s); reaching condition: s * s_dot &lt;= -eta * |s|",
        "H-infinity: min_K ||T_zw(s)||_inf  s.t.  T_zw = LFT(P, K) = closed-loop from w to z",
        "Robust stability (mult.): ||W_m * T||_inf &lt; 1; (add.): ||W_a * K * S||_inf &lt; 1",
        "mu condition: mu_Delta(M(jw)) &lt; 1 for all w  implies  robust stability AND performance",
      ]}/>
    </div>
  );
}